import React from "react";
import OptimizedThinking, { ThinkingProps } from "./Thinking/Thinking";

const Thinking: React.FC<ThinkingProps> = (props) => {
  return <OptimizedThinking {...props} />;
};

export default Thinking;
